import { INavigationItem } from "@origin-digital/navigation-client-sdk";

export const helpLink: INavigationItem = {
  name: "help",
  title: "Help",
  ariaLabel: "Go to Help and Support page",
  icon: "IconHelpOutline",
  href: "/help-support",
};
